export default __webpack_public_path__ + "static/resilience-a55558b425cf7d0c929a0f94ae6e6c92.png";